// Import Dependencies
import { Outlet, ScrollRestoration, useLocation } from "react-router";
import { lazy } from "react";

// Local Imports
import { useAuthContext } from "app/contexts/auth/context";
import { SplashScreen } from "components/template/SplashScreen";
import { Progress } from "components/template/Progress";
import { Loadable } from "components/shared/Loadable";

const Toaster = Loadable(lazy(() => import("components/template/Toaster")));
const Tooltip = Loadable(lazy(() => import("components/template/Tooltip")));

import GlobalCallWidget from "components/global/GlobalCallWidget";
import GlobalLeadDetailModal from "components/global/GlobalLeadDetailModal";
import GlobalSignalRListener from "components/global/GlobalSignalRListener";
import GlobalLoader from "components/global/GlobalLoader";

function Root() {
  const { isInitialized } = useAuthContext();
  const location = useLocation();

  // Check if this is a public route (form pages, etc.)
  const isPublicRoute = location.pathname.startsWith('/form/') ||
    location.pathname.startsWith('/test-form/') ||
    location.pathname.startsWith('/real-form/');


  // For public routes, don't wait for auth initialization
  if (!isPublicRoute && !isInitialized) {
    return <SplashScreen />;
  }

  return (
    <>
      <Progress />
      <ScrollRestoration />
      <Outlet />
      <Tooltip />
      <Toaster />
      <GlobalCallWidget />
      <GlobalLeadDetailModal />
      <GlobalSignalRListener />
      <GlobalLoader />
    </>
  );
}

export default Root;
